import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import Box from '@mui/material/Box';
import { FC, memo } from 'react';
import MiViewTargetCard from '../MiViewTargetCard/MiViewTargetCard';
import useMiViewTargetAccordion from './MiViewTargetAccordion.hook';
import {
  accordionHeaderStyle,
  initialsBlockStyle,
  categoryBlockStyle,
} from './MiViewTargetAccordion.style';
import { MiViewTargetAccordionProps } from './MiViewTargetAccordion.types';

const MiViewTargetAccordionComponent: FC<MiViewTargetAccordionProps> = ({
  target,
  cep,
  tactics,
  opened,
  AEDocuments,
  IVADocuments,
}) => {
  const {
    personInitials,
    readableColor,
    openedState,
    changeOpenState,
    getFullname,
  } = useMiViewTargetAccordion(target, opened);

  return (
    <Box display="block">
      <Box sx={ accordionHeaderStyle } onClick={ changeOpenState }>
        <Box sx={ { ...initialsBlockStyle, background: readableColor } }>
          <Box sx={ categoryBlockStyle }>X</Box>
          { personInitials || <PersonOutlineIcon /> }
        </Box>
        { openedState ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon /> }
        <Box>{ getFullname() }</Box>
      </Box>

      {
        openedState && (
          <MiViewTargetCard
            cep={ cep }
            tactics={ tactics }
            AEDocuments={ AEDocuments }
            IVADocuments={ IVADocuments }
            target={ target }
          />
        )
      }
    </Box>
  );
};

MiViewTargetAccordionComponent.displayName = 'MiViewTargetAccordion';

export default memo(MiViewTargetAccordionComponent);
